// extracted by mini-css-extract-plugin
export default {"container":"change-language_container__kkS7H","body":"change-language_body__x2+w6","language":"change-language_language__w59QE","active":"change-language_active__-Da0R"};